import * as TFF from '@tff/types/TFF';

export const isNewJourneySameAsOriginal = (originalJourney: TFF.Journey, newJourney: TFF.AmendJourney) => {
  if (originalJourney?.Segments.length !== newJourney?.Segments.length) {
    return false;
  }

  return originalJourney?.Segments.every((originalSegment, index) => {
    const newSegment = newJourney?.Segments[index];
    return (
      originalSegment?.Origin === newSegment?.Origin &&
      originalSegment?.Destination === newSegment?.Destination &&
      originalSegment?.ArrivalTime === newSegment?.ArrivalTime &&
      originalSegment?.DepartureTime === newSegment?.DepartureTime
    );
  });
};
